import { useQuery } from "@tanstack/react-query";
import { asyncGetItem } from "../fetch";


const DEFAULT_STALE_TIME = 600000; // 10min

export const fetchPageInfo = async (slug, locale = "vi") => {
  if (!slug) return undefined;
  // if (!locale) return undefined;
  const data = await asyncGetItem({
    collection_name: "news",
    options: {
      condition: {
        ngon_ngu: locale,
        slug,
        shared: true,
        loai_tin_tuc: "Trang tuyển dụng",
      },
    },
  });

  return data;
};

export const useFetchPageInfo = (slug, locale) => useQuery(
    ["pageInfo", slug, locale],
    () => fetchPageInfo(slug, locale),
    {
      staleTime: DEFAULT_STALE_TIME,
    }
  );
